import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { getSelectedOrganization } from "../../helpers/localStorage";
import { useAppStore } from "../../hooks/useStores";
import TabsLayout from "../../layout/TabsLayout/TabsLayout";
import { isEditorRole } from "./RelatedOrganizations/RelatedOrganizationUtils.tsx";
import { ORG_SUBSCRIPTION_PLANS } from "../../constants/billing.ts";

const Account = () => {
	const { t } = useTranslation();
	const { appStore, authStore } = useAppStore();
	const isFreeSubscription = authStore.orgSubscription?.plan_name === ORG_SUBSCRIPTION_PLANS.free.name;
	const subTabs = [
		"usage",
		"api-keys",
		"iframes",
		"users",
		"related-organizations",
		"subscription",
		...(authStore?.user?.isSuperAdmin() ? ["attribution-reports"] : []),
		...(isEditorRole(getSelectedOrganization()?.role ?? "") && !isFreeSubscription ? ["mfa_settings"] : []),
	];
	const selectedOrganization = getSelectedOrganization()?.organization.name ?? "";

	return (
		<>
			<TabsLayout
				title={t("briaOrgSettings", { selectedOrganization })}
				subTabs={subTabs}
				isLoading={appStore.isLoading}
			>
				<Outlet />
			</TabsLayout>
		</>
	);
};

export default observer(Account);
